import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type CreateShortenLinkResponse =
  paths['/api/v1/shorten_links']['post']['responses'][201]['content']['application/json'];

export type GetShortenLinkResponse =
  paths['/api/v1/shorten_links/{key}']['get']['responses'][200]['content']['application/json']['shortenLink'];

export async function createShortenLink(
  artistId: string,
  memberId: string
): Promise<CreateShortenLinkResponse> {
  const { data, error } = await client.POST('/api/v1/shorten_links', {
    body: { shorten_link: { type: 'binder', artist_id: artistId, member_id: memberId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from createShortenLink');
  return data;
}

export async function getShortenLink(key: string): Promise<GetShortenLinkResponse> {
  const { data, error } = await client.GET('/api/v1/shorten_links/{key}', {
    params: { path: { key } }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getShortenLink');
  return data.shortenLink;
}
